<div class="progress-container" [class.compact]="compact">
  <div class="progress-fill" [style.width.%]="progress">
    <div class="progress-label">
      @if (!compact) {
        <span>{{ progress }}%</span>
      }
    </div>
  </div>
</div>
